// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__PnfIg","modalBody":"ConfirmationPop_modalBody__IvV9w"};